import React from 'react';
import T from 'prop-types';

const SubRows = ({ row, columns, maxHeight }) => (
  <div className="sub-rows-container" style={{ maxHeight: row.expandedRowsMaxHeight || maxHeight }}>
    <table className="default-table sub-rows-table">
      <tbody>
        {row.subRows.map((subRow, i) => {
          const cells = columns.map((column) => {
            const cell = subRow[`${column.dataField}_display`] || subRow[column.dataField];
            const cellProps = subRow[`${column.dataField}_td_props`] || {};

            return column.dataField === 'dummy_column' ? (
              <td key={column.dataField} className="empty-cell" />
            ) : (
              <td key={column.dataField} {...cellProps}>
                {cell}
              </td>
            );
          });

          return (
            <tr key={subRow.key || i} className={subRow.rowClassName}>
              {cells}
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

SubRows.propTypes = {
  row: T.shape({
    subRows: T.array.isRequired,
    expandedRowsMaxHeight: T.number,
  }).isRequired,
  columns: T.array.isRequired,
  maxHeight: T.oneOfType([T.string, T.number]),
};

export default SubRows;
